module.exports = __webpack_public_path__ + "static/sinking-ship-logo-13b039e3aa2fa877ca553efa2c9b9db4.png";